import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Input, Row, Col, message, DatePicker } from 'antd'; // Select
import { TimePicker } from "@vaadin/react-components/TimePicker";
import PropTypes from 'prop-types';
import AllCancelPopup from './AllCancelPopup';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import { CallLogDetailData, deleteCallLogId, CalllogUpdate, CalllogSave } from "../../../Api/Services/CallLogApiService"
import { Button } from '../../../components/buttons/buttons';
import { validateShortText } from '../../../components/utilities/utilities';

// const { Option } = Select;

const Popup = ({ setCallLogPopup, callLogPopup, popupType, UrlId, callLogValue, callLogData, AllCallLogs, setNaCTrigger, page }) => {
    // const history = useHistory();
    const [form] = Form.useForm();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const [noteTitle, setNoteTitle] = useState()
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const loadingRef1 = useRef(false);
    const [deleteClick1, setDelteClick1] = useState(false)
    const [noteDescription, setNoteDescription] = useState()
    // const [relatedTo, setRelatedTo] = useState([])
    const [date, setDate] = useState(null)
    const [time, setTime] = useState(null);
    const [noteType, setNoteType] = useState()
    const [noteRelatedTo, setNoteRelatedTo] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    function convertDateFromProfile(date, time, company, profile) {
        if (!company?.timeZone || !profile?.timeZone) return { date: "", time: "" };
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(profile.timeZone);
        const toTimezone = extractTimezoneName(company.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return { date: "", time: "" };
        }
        const nowInProfile = moment.tz(fromTimezone);
        const datePart = date || nowInProfile.format("YYYY-MM-DD");
        const timePart = time || nowInProfile.format("HH:mm");
        const dateTimeString = `${datePart} ${timePart}`;
        const dateWithTime = moment.tz(dateTimeString, "YYYY-MM-DD HH:mm", fromTimezone);
        if (!dateWithTime.isValid()) {
            console.warn("Invalid date/time input");
            return { date: "", time: "" };
        }
        const converted = dateWithTime.clone().tz(toTimezone);
        return {
            date: converted.format("YYYY-MM-DD"),
            time: converted.format("HH:mm")
        };
    }
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    // const ReferApi = async () => {
    //     const noteRelatedTO = noteRelatedTo?.join(',')
    //     const formData =
    //     {
    //         CallTitle: noteTitle && noteTitle !== "" ? noteTitle : "Untitled",
    //         callDesc: noteDescription && noteDescription !== "" ? noteDescription : "Call Log Description",
    //         relatedTo: noteType,
    //         relatedId: noteRelatedTO,
    //         callDate: date,
    //         callTime: time
    //     }
    //     await CalllogUpdate(formData, callLogData?.callLogId)
    // }
    const handleClose = () => {
        setCallLogPopup(false);
        // if (page === "CallUi") {
        //     ReferApi()
        // }
    }
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const handleTypeChange = async (value) => {
        setNoteType(value)
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const setData = (value) => {
        if (value !== undefined) {
            const dateTime = convertDateFromProfile(value.callDate, value.callTime, profile, companyProfile)
            setDate(dateTime.date)
            setTime(dateTime.time)
            form.setFieldsValue({
                callDate: moment(formatDateString(dateTime.date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                callTime: dateTime.time,
                title: value.CallTitle,
            })
            setNoteTitle(value.CallTitle)
            setNoteDescription(value.callDesc)
            setNoteType(value.relatedTo)
            handleTypeChange(value.relatedTo)
            setNoteRelatedTo(value.relatedId?.split(",").map(user => user * 1))
        }
    }
    useEffect(() => {
        if (UrlId !== undefined && UrlId !== null && page !== "CallUi") { //
            if (UrlId[0] === "?LEAD") {
                handleTypeChange("Lead")
            }
            else if (UrlId[0] === "?CONTACT") {
                handleTypeChange("Contact")
            }
            else if (UrlId[0] === "?ACCOUNT") {
                handleTypeChange("Account")
            }
            else if (UrlId[0] === "?DEAL") {
                handleTypeChange("Deal")
            }
            else if (UrlId[0] === "?TASK") {
                handleTypeChange("Task")
            }
            else if (UrlId[0] === "?MEETING") {
                handleTypeChange("Meeting")
            }
            else if (UrlId[0] === "?CASE") {
                handleTypeChange("Case")
            }
            setNoteRelatedTo([UrlId[1] * 1])
            form.setFieldsValue({
                callDate: null,
                callTime: null,
                title: null,
            })
        }
        else if (page === "CallUi") {
            handleTypeChange(callLogData.type)
            setDate(callLogData.triggeredDate)
            setTime(callLogData.triggeredTime)
            setNoteTitle(callLogData.type === "Case" ? `${callLogData.data.name}-${callLogData.triggeredDate}` : `${callLogData.data.first_name} ${callLogData.data.last_name}-${callLogData.triggeredDate}`)
            setNoteRelatedTo(
                (callLogData.type === "Lead" ? [callLogData.data.leads_id] :
                    callLogData.type === "Contact" ? [callLogData.data.contacts_id] :
                        callLogData.type === "Case" ? [callLogData.caseId] :
                            [0])
            )
        }
    }, [UrlId])
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        // if (page !== "CallUi") {
        const dateTimeObject = convertDateFromProfile(date, time, companyProfile, profile)
        const noteRelatedTO = noteRelatedTo.join(',')
        const formData =
        {
            CallTitle: normalizeValue(noteTitle && noteTitle !== "" ? noteTitle : "Untitled"),
            callDesc: normalizeValue(noteDescription && noteDescription !== "" ? noteDescription : "Call Log Description"),
            relatedTo: noteType,
            relatedId: noteRelatedTO,
            callDate: dateTimeObject.date,
            callTime: dateTimeObject.time
        }
        try {
            if (popupType === "Create") {
                const response = await CalllogSave(formData)
                if (response.status === 201) {
                    message.success("Call log created")
                    setCallLogPopup(false)
                    setNaCTrigger("CallBack")
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
            else {
                const response = await CalllogUpdate(formData, callLogValue)
                if (response.status === 200) {
                    message.success("Call log updated")
                    AllCallLogs()
                    setNaCTrigger("CallBack")
                    setCallLogPopup(false)
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
        } catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
        // }
        // else {
        //     const noteRelatedTO = noteRelatedTo?.join(',')
        //     const formData =
        //     {
        //         CallTitle: noteTitle && noteTitle !== "" ? noteTitle : "Untitled",
        //         callDesc: noteDescription && noteDescription !== "" ? noteDescription : "Call Log Description",
        //         relatedTo: noteType,
        //         relatedId: noteRelatedTO,
        //         callDate: date,
        //         callTime: time
        //     }
        //     try {
        //         const response = await CalllogUpdate(formData, callLogData?.callLogId)
        //         if (response.status === 200) {
        //             message.success("Call log created")
        //             setCallLogPopup(false)
        //             setNaCTrigger("CallBack")
        //             loadingRef.current = false;
        //             setDelteClick(false)
        //         }
        //     } catch (error) {
        //         loadingRef.current = false;
        //         setDelteClick(false)
        //         message.error(error)
        //     }
        // }
    }
    const getNotesDetails = async () => {
        try {
            const response = await CallLogDetailData(callLogValue);
            setData(response);
        }
        catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (callLogValue) {
            getNotesDetails()
        }
    }, [callLogValue])
    const handleDelete = async (id) => {
        if (loadingRef1.current) return;
        loadingRef1.current = true;
        setDelteClick1(true)
        try {
            const response = await deleteCallLogId(id);
            if (response.status === 200) {
                message.success("Call log deleted")
                AllCallLogs()
                setNaCTrigger("CallBack")
                setCallLogPopup(!callLogPopup)
                loadingRef1.current = false;
                setDelteClick1(false)
            }
        }
        catch (error) {
            loadingRef1.current = false;
            setDelteClick1(false)
            message.error(error)
        }
    }
    const handleDate = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDate(formattedDate);
    };
    const handleTime = (event) => {
        const selectedTime = event.target.value;
        setTime(selectedTime);
    };
    const PageCancel1 = () => {
        if (popupType === "Update") {
            handleClose()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const handleChange1 = (val) => {
        setNoteDescription(val);
    };
    return (
        <>
            <Modal
                title={
                    popupType === "Update" ?
                        <span>
                            Update Call Log
                            {noteTitle && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {noteTitle}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Call Log"
                }
                open={callLogPopup}
                onCancel={PageCancel1}
                maskClosable={false}
                width={700}
                footer={[
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        {popupType === "Update" ?
                            <>
                                <Button onClick={PageCancel1} className="gray-button" size="small">
                                    <FeatherIcon icon="x" />Cancel
                                </Button>
                                <Button onClick={() => handleDelete(callLogValue)} className="red-button" size="small" loading={deleteClick1} disabled={deleteClick1}>
                                    {!deleteClick1 && <FeatherIcon icon="trash-2" />}Delete
                                </Button>
                                <Button className='btn-add_new button_colors' size="small"
                                    onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}
                                >
                                    {!deleteClick && <FeatherIcon icon="save" />}Update
                                </Button>
                            </>
                            :
                            <>
                                <Button onClick={PageCancel1} className="gray-button" size="small" >
                                    <FeatherIcon icon="x" />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' size="small"
                                    onClick={() => form.submit()} loading={deleteClick} disabled={deleteClick}
                                >
                                    {!deleteClick && <FeatherIcon icon="save" />}Save
                                </Button>
                            </>}
                    </div>
                ]}
            >
                <AddUser>
                    <div className="user-info-form">
                        <BasicFormWrapper>
                            <Form style={{ width: '100%' }} form={form} name="AddCallLog" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed} >
                                <Row gutter={30} style={{ padding: "0px 20px" }}>
                                    {/* {page !== "CallUi" ? */}
                                    <Col span={24} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Title" name="title" id="title"
                                            rules={[{
                                                required: true,
                                                transform: (value) => value?.trim(), message: 'Please enter title'
                                            }]}>
                                            <Input value={noteTitle}
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const error = validateShortText(inputValue, 50);
                                                    if (error) {
                                                        message.error(error);
                                                        return;
                                                    }
                                                    setNoteTitle(inputValue);
                                                }} placeholder="Untitled" />
                                        </Form.Item>
                                    </Col>
                                    {/* : <></>} */}
                                    {/* < Col span={24} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Type">
                                            <Select style={{ width: '100%' }}
                                                placeholder="Select Type"
                                                value={noteType}
                                                onChange={handleTypeChange}
                                            >
                                                <Option value="Lead">Lead</Option>
                                                <Option value="Contact">Contact</Option>
                                                <Option value="Account">Account</Option>
                                                <Option value="Deal">Deal</Option>
                                                <Option value="Task">Task</Option>
                                                <Option value="Meeting">Meeting</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {noteType !== null && noteType !== "Personal" &&
                                        <Col span={24} style={{ marginBottom: 10 }}>
                                            <Form.Item label="Related to">
                                                <Select style={{ width: '100%' }} showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    } mode="multiple"
                                                    value={noteRelatedTo}
                                                    onChange={handleRelatedToChange}>
                                                    {relatedTo}
                                                </Select>
                                            </Form.Item>
                                        </Col>} */}
                                    {/* {page !== "CallUi" ? <> */}
                                    <Col span={12} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Call Date" name="callDate"
                                            id="callDate" rules={[{ required: true, message: 'Please select call Date' }]}>
                                            <DatePicker className='Date-Picker'
                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                value={date ? moment(date, "YYYY-MM-DD") : null}
                                                onChange={handleDate} disabledDate={(current) => {
                                                    return current && current > moment().endOf('day');
                                                }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Call Time" name="callTime"
                                            id="callTime" rules={[{ required: true, message: 'Please select call Time' }]}>
                                            <TimePicker className="custom-timepicker"
                                                value={time}
                                                // clearButtonVisible 
                                                step={1800} placeholder="Time" onChange={handleTime} />
                                            {/* <TimePicker
                                                value={time ? moment(time, "HH:mm") : null}
                                                format={profile.timeFormat === "12hrs" ? "hh:mm A" : "HH:mm"}
                                                onChange={handleTime}
                                            /> */}
                                        </Form.Item>
                                    </Col>
                                    {/* </> : <></>} */}
                                    <Col span={24} style={{ marginBottom: 10 }}>
                                        <Form.Item label="Description">
                                            <TinyMCEEditor
                                                placeholder="Enter Description"
                                                content={noteDescription}
                                                setContent={handleChange1}
                                                edit
                                                page="TextBoxs"
                                                height={150}
                                                selectedEntity="A"
                                            />
                                            {/* <Input.TextArea rows={3} value={noteDescription} maxLength={2500} showCount placeholder='Enter Description'
                                                onChange={(e) => {
                                                    const inputValue = e.target.value;
                                                    const error = validateDescriptionField(inputValue, 2500);
                                                    if (error) {
                                                        message.error(error);
                                                        return;
                                                    }
                                                    setNoteDescription(inputValue);
                                                }} /> */}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </BasicFormWrapper>
                    </div>
                </AddUser>
            </Modal >
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={handleClose} />}
        </>
    );
};

Popup.propTypes = {
    callLogPopup: PropTypes.bool.isRequired,
    setCallLogPopup: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    UrlId: PropTypes.array.isRequired,
    callLogValue: PropTypes.number.isRequired,
    AllCallLogs: PropTypes.func.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    // CallData: PropTypes.object.isRequired,
    // activeCallNumber: PropTypes.number.isRequired,
    page: PropTypes.string.isRequired,
    callLogData: PropTypes.object.isRequired,
};

export default Popup;